export default __webpack_public_path__ + "static/media/undraw_posting_photo.56b1cd9e.svg";